export default {
  'routes.customRoutes': {
    routes: [],
    notFoundRoute: null,
  },
};
